// Models

export const PROPS_LICENSE_NUMBER = "licenseNumber";
export const PROPS_EXPIRATION_DATE = "expirationDate";
export const PROPS_STATE_GUID = "stateGuid";
export const PROPS_LICENSE_TYPE_GUID = "licenseTypeGuid";
export const PROPS_LICENSE_TYPE_NAME = "licenseTypeName";
export const PROPS_COUNTRY_GUID = "countryGuid";
